import {
  VIDFLEET_VIDEO_START_STREAMING,
  VIDFLEET_VIDEO_START_STREAMING_RESPONSE,
  VIDFLEET_VIDEO_STOP_STREAMING,
  VIDFLEET_VIDEO_STOP_STREAMING_RESPONSE,
  VIDFLEET_VIDEO_GET_STREAMING_STATUS,
  VIDFLEET_VIDEO_GET_STREAMING_STATUS_RESPONSE,
  VIDFLEET_VIDEO_GET_CLIP_BY_ID,
  VIDFLEET_VIDEO_GET_CLIP_BY_ID_RESPONSE,
  VIDFLEET_VIDEO_GET_PICTURE_BY_ID,
  VIDFLEET_VIDEO_GET_PICTURE_BY_ID_RESPONSE,
  VIDFLEET_VIDEO_GET_ONLINE_STATUS,
  VIDFLEET_VIDEO_GET_ONLINE_STATUS_RESPONSE,
  VIDFLEET_VIDEO_MODAL_SHOW,
  VIDFLEET_VIDEO_MODAL_HIDE,
  VIDFLEET_VIDEO_GET_CLIP_REQUEST_REQUEST,
  VIDFLEET_VIDEO_GET_CLIP_REQUEST_RESULT,
} from 'Redux/actionTypes';

export const vidFleetVideoGetClipRequest = (id) => ({
  type: VIDFLEET_VIDEO_GET_CLIP_REQUEST_REQUEST,
  payload: { id },
});


export const vidFleetVideoGetClipRequestResult = (data) => ({
  type: VIDFLEET_VIDEO_GET_CLIP_REQUEST_RESULT,
  payload: data,
});


export const vidFleetVideoStartStreaming = (data) => ({
  type: VIDFLEET_VIDEO_START_STREAMING,
  payload: { data },
});

export const vidFleetVideoStartStreamingResponse = (data) => ({
  type: VIDFLEET_VIDEO_START_STREAMING_RESPONSE,
  payload: { data },
});

export const vidFleetVideoStopStreaming = (data) => ({
  type: VIDFLEET_VIDEO_STOP_STREAMING,
  payload: { data },
});

export const vidFleetVideoStopStreamingResponse = (data) => ({
  type: VIDFLEET_VIDEO_STOP_STREAMING_RESPONSE,
  payload: { data },
});

export const vidFleetVideoGetStreamingStatus = (data) => ({
  type: VIDFLEET_VIDEO_GET_STREAMING_STATUS,
  payload: { data },
});

export const vidFleetVideoGetStreamingStatusResponse = (data) => ({
  type: VIDFLEET_VIDEO_GET_STREAMING_STATUS_RESPONSE,
  payload: { data },
});

export const vidFleetVideoGetClipById = (data) => ({
  type: VIDFLEET_VIDEO_GET_CLIP_BY_ID,
  payload: { data },
});

export const vidFleetVideoGetClipByIdResponse = (data) => ({
  type: VIDFLEET_VIDEO_GET_CLIP_BY_ID_RESPONSE,
  payload: { data },
});

export const vidFleetVideoGetPictureById = (data) => ({
  type: VIDFLEET_VIDEO_GET_PICTURE_BY_ID,
  payload: { data },
});

export const vidFleetVideoGetPictureByIdResponse = (data) => ({
  type: VIDFLEET_VIDEO_GET_PICTURE_BY_ID_RESPONSE,
  payload: { data },
});

export const vidFleetVideoGetCameraOnlineStatus = (data) => ({
  type: VIDFLEET_VIDEO_GET_ONLINE_STATUS,
  payload: { data },
});

export const vidFleetVideoGetCameraOnlineStatusResponse = (data) => ({
  type: VIDFLEET_VIDEO_GET_ONLINE_STATUS_RESPONSE,
  payload: { data },
});

export const vidFleetVideoOpenModal = (data, detail, clipRequestId) => ({
  type: VIDFLEET_VIDEO_MODAL_SHOW,
  payload: { data, detail, clipRequestId },
});

export const vidFleetVideoCloseModal = () => ({
  type: VIDFLEET_VIDEO_MODAL_HIDE,
  payload: {},
});